import {Component, computed, inject, input, signal} from '@angular/core';
import {ICompareItem} from '../../../../../types/ICompareItem';
import {IAddonForItem} from '../../../../../types/IAddonForItem';
import {ButtonComponent} from '../../../../../shared/components/button/button.component';
import {CurrencyPipe, UpperCasePipe} from '@angular/common';
import {IconsComponent} from '../../../../../shared/components/icons/icons.component';
import {ItemImageComponent} from '../../../../../shared/components/item-image/item-image.component';
import {getFeatureString} from '../../../../../shared/utils/item.utils';
import {background, containerClasses, stars} from '../../../../../shared/utils/comparison.utils';
import {SelectionStore} from '../../../selection.store';
import {
  ResultsItemDetailsModal
} from '../../../../results/components/results-item-details-modal/results-item-details-modal';
import {Accordion} from '../../../../../shared/components/accordion/accordion';
import {Hr} from '../../../../../shared/components/hr/hr';
import {IAvailabilitySource} from '../../../../../types/IAvailabilitySource';

@Component({
  selector: 'app-selection-item',
  imports: [
    ButtonComponent,
    CurrencyPipe,
    IconsComponent,
    ItemImageComponent,
    UpperCasePipe,
    ResultsItemDetailsModal,
    Accordion,
    Hr
  ],
  templateUrl: './selection-item.component.html',
  styleUrl: './selection-item.component.css'
})
export class SelectionItemComponent {
  level = input.required<string>();
  item = input.required<ICompareItem>();
  addons = input<IAddonForItem | null>(null);
  maxAddonRows = input<number>(0);
  maxFeeRows = input<number>(0);

  showDetails = signal(false);
  readonly selectionStore = inject(SelectionStore);

  price = computed(() => {
    const sourcing = this.item().sourcing ?? [];
    const totalQty = sourcing.reduce((sum, s) => sum + (s.selected_quantity || 0), 0);
    if (totalQty === 0) return 0;
    return sourcing.reduce((sum, s) => sum + (s.selected_quantity || 0) * (s.price || 0), 0) / totalQty;
  });

  selectItem() {
    this.selectionStore.selectGrade(this.level() as 'good' | 'better' | 'best');
  }

  isSelected = computed(() => this.selectionStore.selected() === this.level());

  readonly includedAddons = computed(() => (this.addons()?.addons ?? []));
  readonly subtotal = computed(() => this.addons()?.subtotal_before_addons ?? 0);
  readonly fees = computed(() => this.addons()?.fees ?? []);
  readonly taxAfterAddons = computed(() => this.addons()?.tax_after_addons ?? 0);
  readonly totalAfterAddons = computed(() => this.addons()?.total_after_addons ?? 0);
  readonly addonPadRows = computed(() => Array(Math.max(0, this.maxAddonRows() - this.includedAddons().length)).fill(null));
  readonly feePadRows = computed(() => Array(Math.max(0, this.maxFeeRows() - this.fees().length)).fill(null));
  readonly disabled = computed(() => this.isSelected() || this.selectionStore.isSubmitFulfilled() || this.selectionStore.isSubmitPending());

  protected readonly containerClasses = containerClasses;
  protected readonly background = background;
  protected readonly stars = stars;
  protected readonly getFeatureString = getFeatureString;
}
